import React from 'react';
import { Button } from '../../../components/ui/Button';
import { Transaction } from '../../../types/transactions';
import { formatRupiah } from '../../../utils/format';

export type DetailViewProps = {
  data: Transaction | null;
  loading?: boolean;
  error?: string | null;
  onBack: () => void;
};

export const TransactionDetailView: React.FC<DetailViewProps> = ({ data, loading, error, onBack }) => {
  return (
    <div className="w-full">
      <div className="mb-3 flex items-center justify-between">
        <h1 className="text-xl font-semibold">Transaction Details</h1>
        <div className="flex gap-2">
          <Button variant="outline" onClick={onBack}>Back</Button>
        </div>
      </div>
      {loading && <div>Loading...</div>}
      {error && <div className="text-sm text-destructive">{error}</div>}
      {data && (
        <div className="rounded border p-4">
          <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
            <Field label="ID" value={String(data.id)} />
            <Field label="Date" value={data.createdAt ? new Date(data.createdAt).toLocaleString() : '-'} />
            <Field label="Machine" value={data.machine?.name || String(data.machineId)} />
            <Field label="Product" value={data.product?.name || String(data.productId)} />
            <Field label="Quantity" value={String(data.qty)} />
            <Field label="Unit Price" value={formatRupiah(data.unitPrice)} />
            <Field label="Total" value={formatRupiah(data.qty * data.unitPrice)} />
            <Field label="Order ID" value={data.orderId || '-'} />
          </div>
        </div>
      )}
    </div>
  );
};

const Field: React.FC<{ label: string; value: string }> = ({ label, value }) => (
  <div>
    <div className="text-xs text-muted-foreground">{label}</div>
    <div className="mt-1 text-sm">{value}</div>
  </div>
);

export default TransactionDetailView;
